import React from 'react';
import styled from 'styled-components';
import CardComponent, { StyledCard } from '../Card.component';
import IconButtonComponent from '../IconButton.component';
import CrossIcon from '../Icons/Cross.icon';
import { useTranslation } from 'react-i18next';
import ButtonComponent, { StyledButton } from '../Button.component';
import { useModalManager } from '../../hooks/ModalManager.hook';

export interface ChildAlertProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  handleConfirm: Function;
}

export interface BaseAlertProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode;
  icon?: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: Function;
}

export interface BaseAlert2Props extends BaseAlertProps {
  onClose?: Function;
}

export const StyledBaseAlertFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  ${StyledButton} {
    flex: 1 1 auto;
  }
`;
export const StyledBaseAlertBodyIcon = styled.div`
  margin-left: -15px;
  padding: 0 15px;
`;
const StyledBaseAlertBodyContent = styled.div`
  font-weight: 500;
  max-width: 60vw;
`;
const StyledBaseAlertBody = styled.div`
  padding: 20px 15px 20px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
const StyledBaseAlertHeaderTitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
`;
const StyledBaseAlertHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledBaseAlert = styled.div`
  ${StyledCard} {
    min-width: 285px;
    padding: 10px 12px 12px;
    animation: ${({ theme }) => theme.animations.slide.modal} 0.2s ease-in-out
      forwards;
  }
`;

const BaseAlertComponent = ({
  header,
  icon,
  footer,
  children,
  onClose,
}: BaseAlertProps) => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();
  return (
    <StyledBaseAlert>
      <CardComponent>
        <StyledBaseAlertHeader>
          <StyledBaseAlertHeaderTitle>
            {header || t('Alert')}
          </StyledBaseAlertHeaderTitle>
          <IconButtonComponent
            onClick={() => (onClose ? onClose() : closeModal())}
          >
            <CrossIcon />
          </IconButtonComponent>
        </StyledBaseAlertHeader>
        <StyledBaseAlertBody>
          {icon && <StyledBaseAlertBodyIcon>{icon}</StyledBaseAlertBodyIcon>}
          <StyledBaseAlertBodyContent>{children}</StyledBaseAlertBodyContent>
        </StyledBaseAlertBody>
        <StyledBaseAlertFooter>
          {footer || (
            <ButtonComponent
              handleClick={() => (onClose ? onClose() : closeModal())}
            >
              {t('Close')}
            </ButtonComponent>
          )}
        </StyledBaseAlertFooter>
      </CardComponent>
    </StyledBaseAlert>
  );
};

export default BaseAlertComponent;
